module.exports = __webpack_public_path__ + "static/media/clipboard-icon-white.67177333.svg";